/* contenido de la propuesta seleccionada */

//*react- recursos
   import { useState, useEffect} from "react";

//*componentes-utiles

//*clases 
    import ReactTooltip from "react-tooltip";
    import '../../../../css/mdi.css'; 
    import { Col, Row } from "react-bootstrap";

//*archivos (imagenes y elementos necesarios para la rutina)

//*api's (servicios y store)
    import analysisStore from "../../../../api/recursos/analysis/analysis.store"; 

//*store's

//*datos
    import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json";
    import articulos from "../../../../datos/json/guidelines.json";

//*funciones

//*interfaces
    interface propsRDEvidencias {
        pfcId : any;
        evId: any;
        miCatPruebas: any;
        miCatCaracteristicas: any;
        activaBotonGuardar: any;
        activaBotonEnviar: any;
        desactivaBotonGuardarEnviar: any;
        recargaRDDocumentar: any;
        recargaRD: any;
        recargaPaginaSSC: any;
        recargaPaginaSSC_Not: any;
    }
//*componente
 export default function RDEvidencias(props: propsRDEvidencias) {  
    //*api store

        const { cambiaPFCDetalleStore, } =  
            analysisStore((state:any) =>( { 
                cambiaPFCDetalleStore: state.cambiaPFCDetalleStore
        }));

    //*store's
    //*datos

    //*constantes y variables
        let eti = etiquetasSSC.RD;
        let x0,x1 = ""; 

    //*useState
        const [swRecarga, setSwRecarga] =  useState(false);
        const [swRecargaRDDocumentarEvidencias, setSwRecargaRDDocumentarEvidencias] =  useState(false);

    //*useEffect
        useEffect(()=> { // uso este puente para recargar elementos del front, no uso ese useState
           //console.log('miCatPruebas: ', props.miCatPruebas);
           //console.log('miCatCaracteristicas: ', props.miCatCaracteristicas);
           setSwRecarga(!swRecarga);
           props.recargaRDDocumentar();
        },[]);

        useEffect(()=> {  //usado para renderizar
            //console.log('RD.Documentar.Evidencias .... renderizando...');
            setSwRecargaRDDocumentarEvidencias(!swRecargaRDDocumentarEvidencias);
        },[swRecarga]);

    //*interface (parametros de entrada)

    //*funciones
        const recargaPaginaSSC = () => { props.recargaPaginaSSC() } //ejecuta la función que esta en RD

        const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() } //ejecuta la función que esta RD

        const recargaRDDocumentar = () => { props.recargaRDDocumentar() } //ejecuta la función que esta en RD

        const recargaRDDocumentarEvidencias = () => { 
            setSwRecarga(!swRecarga)
        }
        const cambiaCheckCaracteristicas = (e:any) => {
            //alert('cambiaCheckCaracteristicas:' + e.target.id);
            //console.log('e.target.id::', e.target.id);
            //console.log('e.target.value::', e.target.value);
            //catEC_${props.evId}_${c.id}  = catEC_8_14
            let miCheckId = e.target.id;
            let posP = miCheckId.indexOf('_');
            let paso = miCheckId.substr( posP+1, miCheckId.length-posP );
            let posC = paso.indexOf('_');
            let idEvi = paso.substr( 0, posC );
            let catalogoId = paso.substr(posC+1, paso.length-posC-1 );
            //console.log('*****idEvidencia....', idEvi);
            //console.log('*****catalogoId.....', catalogoId);
            //lo cambio para mi vista frontend
                let swActiva = false;
                props.miCatCaracteristicas.map((ce:any) => {
                    if (ce.id == catalogoId)  { ce.activo = !ce.activo };
                    if (ce.activo)  { swActiva=true };
                }); 
            //lo cambio en mi variable store    
                let copiaMiCatCaracteristicas= JSON.parse(JSON.stringify(props.miCatCaracteristicas));
                cambiaPFCDetalleStore(props.pfcId, idEvi, copiaMiCatCaracteristicas, swActiva, 'cambiaCheckCaracteristicas') ;
            props.activaBotonGuardar();
            setSwRecarga(!swRecarga);
            //props.recargaRDDocumentar();
        };

        const cambiaCheckPruebas = (e:any) => {
            //alert('cambiaCheckPruebas:' + e.target.id  + '...' + e.target.checked);
            //catEP_8_1
            //console.clear();

            let miCheckId = e.target.id;
            let miCheckValor =  e.target.checked;
            let posP = miCheckId.indexOf('_');
            let paso = miCheckId.substr( posP+1, miCheckId.length-posP );
            let posC = paso.indexOf('_');
            let idEvi = paso.substr( 0, posC );
            let catalogoId = paso.substr(posC+1, paso.length-posC-1 );
            //console.log('*****idEvidencia....', idEvi);
            //console.log('*****catalogoId.....', catalogoId);

            //lo cambio para mi vista frontend
            let swActiva = false;
            if (catalogoId == 6) { //selecciono Ninguno (activo)por lo tanto quita todos salen menos el
                swActiva = miCheckValor;
                props.miCatPruebas.map((cp:any) => {
                    if (cp.name != 'Ninguno') {  cp.activo = false }
                    else { cp.activo = !cp.activo  };
                });
                props.miCatPruebas[5].otraTexto='';
            }
            else{
                props.miCatPruebas.map((cp:any) => {
                    if (cp.id == catalogoId)  { cp.activo = !cp.activo }
                    if (cp.name == 'Ninguno') { cp.activo = false }
                    if (cp.activo)  { swActiva=true };
                    if (cp.name == 'Otra' && cp.activo && cp.otraTexto=='')  {  swActiva=false };
                });
            }
            //alert('swActiva...'+swActiva)
                /* if (catalogoId == 6 ) { //selecciono Ninguno por lo tanto quita todos salen menos el
                    props.miCatPruebas.map((cp:any) => {
                        if (cp.name != 'Ninguno') { cp.activo = false }
                        else { cp.activo = !cp.activo };
                    });
                    if (props.miCatPruebas[5].activo) { swActiva=true }
                    //props.pfcDetallesFront.misArchivos[5].activo = true
                }
                else {
                    props.miCatPruebas.map((cp:any) => {
                        if (cp.id == catalogoId) { cp.activo = !cp.activo }
                        if (cp.name == 'Ninguno') { cp.activo = false }
                        if (cp.activo)  { swActiva=true };
                        if (cp.name == 'Otra' && cp.activo && cp.otraTexto=='')  {  swActiva=false };
                    });
                } */

            //lo cambio en mi variable store    
            let copiaMiCatPruebas= JSON.parse(JSON.stringify(props.miCatPruebas));
            cambiaPFCDetalleStore(props.pfcId, idEvi, copiaMiCatPruebas, swActiva, 'cambiaCheckPruebas');
            recargaRDDocumentar();     
            props.activaBotonGuardar();
            setSwRecarga(!swRecarga);
            ////recargaRDDocumentar();
          
        };

        const cambiaTextoPruebasOtro = (e:any) => {
            //alert('cambiaTextoPruebasOtro:' + e.target.id);
            console.log('*****e.target.value.....', e.target.value)
            let miCheckId = e.target.id;
            let posP = miCheckId.indexOf('_');
            let paso = miCheckId.substr( posP+1, miCheckId.length-posP );
            let posC = paso.indexOf('_');
            let idEvi = paso.substr( 0, posC );
            let catalogoId = paso.substr(posC+1, paso.length-posC-1 );
            //console.log('*****idEvidencia....', idEvi);
            //console.log('*****catalogoId.....', catalogoId);
            //lo cambio para mi vista frontend
                props.miCatPruebas[4].otraTexto = e.target.value; 
                //console.log('*****props.miCatPruebas.....', props.miCatPruebas)
                let swActiva = false;
                if (props.miCatPruebas[4].otraTexto != '') { swActiva = true };
            //lo cambio en mi variable store
                let copiaMiCatPruebas= JSON.parse(JSON.stringify(props.miCatPruebas));
                cambiaPFCDetalleStore(props.pfcId, idEvi, copiaMiCatPruebas, swActiva, 'cambiaTextoPruebasOtro') ;
            props.activaBotonGuardar();
            setSwRecarga(!swRecarga);
            //props.recargaRDDocumentar();
           
        }

    //*vista
     return (
         <>
            {/* contenido propuesta */}
            <div className="margin-left-1r">
                <Row className='width-98'>

                     {/* caracteristicas */}
                     <Col sm={6} className="small align-1 height-100">
                        <div className=" padding-1r background-color-white height-100">
                            <div className="color-azul3">
                                {/* titulo: caracteriscas & articulo */}
                                    <div>
                                        <b>{eti.etiquetas[10].text}</b>
                                        <span >
                                            <button className="btnRT9"  data-tip data-for="articulo12"> {eti.etiquetas[10].text2} </button>
                                            <ReactTooltip  id="articulo12" type="info"  place="right" multiline >
                                                {articulos.hybridArticles[0].ch} <br/><br/>
                                                    Articulo: 12<br /> {articulos.hybridArticles[0].art[3].description}<br/><br />
                                            </ReactTooltip>
                                        </span>  
                                    </div>
                                {/* lista de caractericas de la evidencia seleccionada */}
                                    { props.miCatCaracteristicas?.map((c:any, indexC:any) => (
                                        (x0 =  `catEC_${props.evId}_${c.id}`),
                                        (<>
                                            <div className="divCatD_RP ">
                                                <input 
                                                    type="checkbox"
                                                    id={x0} 
                                                    onClick={ cambiaCheckCaracteristicas } 
                                                    checked={c.activo} 
                                                />
                                            </div>
                                            <div style={{display:"inline-block"}}><span className=' padding-botton-1r color-Gris1 cursorHand' title={c.name}> {c.nombreCorto} </span> </div>
                                            <br/>
                                        </>)
                                    ))}
                            </div>
                        </div>
                        <br/>
                     </Col>

                     {/* pruebas */}
                     <Col sm={6} className="small align-1 ">
                        <div className=" padding-1r background-color-white height-100">
                            <div className="color-azul3">
                                {/* titulo: pruebas & articulo */}
                                  <div>
                                        <b>{eti.etiquetas[11].text}</b>
                                        <span >
                                            <button className="btnRT9" data-tip data-for="articulo13"> {eti.etiquetas[11].text2} </button>
                                            <ReactTooltip  id="articulo13" type="info"  place="right" multiline >
                                                {articulos.hybridArticles[0].ch} <br/><br/>
                                                    Articulo: 13<br /> {articulos.hybridArticles[0].art[4].description}<br/><br />
                                            </ReactTooltip>
                                        </span>  
                                  </div>
                                {/* lista de pruebas de la evidencia seleccionada */}  
                                    { props.miCatPruebas?.map((p:any, indexC:any) => (
                                        (x0 =  `catEP_${props.evId}_${p.id}`),
                                        (x1 =  `otroDesc_${props.evId}_${p.id}`),
                                        (<>
                                            <div className="divCatD_RP ">
                                                <input 
                                                    type="checkbox"
                                                    id={x0} 
                                                    onClick={ cambiaCheckPruebas } 
                                                    checked={p.activo} 
                                                />
                                            </div>
                                            <div style={{display:"inline-block"}}><span className=' padding-botton-1r color-Gris1 cursorHand' title={p.name}> {p.nombreCorto} </span> </div>
                                            <br/>
                                            {/* otro: capturamos texto */}
                                                { p.id == 5 && p.activo &&
                                                    (<>  
                                                        <div><input id={x1} type="text" className="inputTexto" value={p.otraTexto}  onChange={ cambiaTextoPruebasOtro }  /></div>
                                                    </>)  
                                                }
                                        </>)
                                    ))}
                            </div>
                        </div>
                     </Col>
                </Row>    
            </div>    
         </>
     );
 }

